

export default {
  addComponentData (state, data) {
    state.componentData[data.name] = data.data
  },
  clearComponentData (state) {
    state.componentData = {}
  },
  setChatId (state, chatId) {
    state.chatId = chatId
  },
  clearChatId (state) {
    state.chatId = null
  },
}
